import type { UserBook } from "../../../services/firebase/booksService";

/**
 * Escolhe UM livro para a vitrine `/lendo` — determinístico, não os até-3 do
 * hero do perfil (`usePublicProfileState.readingNow`). Ver
 * `docs/systems/lendo-page.md` §3.2.
 *
 * `books` precisa já vir ordenado por `updatedAt` desc (`fetchShelfSample`
 * garante isso, inclusive depois de completar a janela) — esta função só
 * filtra por status em memória,
 * sem 2ª leitura.
 *
 * Prioridade: "reading" tocado mais recentemente > "read" mais recente >
 * nenhum (estante sem os dois, ou vazia — a página cai no estado neutro).
 *
 * ⚠️ Para "read" a ordem usada é a MESMA `updatedAt`, não `finishedAt`. Os
 * dois campos nascem juntos na conclusão (`updateProgress`); pedir
 * `finishedAt` separado custaria uma 2ª leitura para um caso que só diverge
 * quando o livro é editado DEPOIS de terminado (nota, troca de formato) —
 * raro, e o pior caso é mostrar "tocado por último" em vez de "lido por
 * último", não um livro errado.
 */
export function selectCurrentReadingBook(books: readonly UserBook[]): UserBook | null {
  const reading = books.find((b) => b.status === "reading");
  if (reading) return reading;
  return books.find((b) => b.status === "read") ?? null;
}
